<script lang="ts">
import { defineComponent } from 'vue';
import PlantApi from '@/data/plants/PlantApi.ts';
import Company from '@/domain/model/business/Company';
import Plant from '@/domain/model/business/Plant.ts';
import YieldPromiseStatus from '@/domain/model/business/YieldPromiseStatus.ts';
import LongTermPeriodSettingsHelper from '@/presentation/components/long-term-period/LongTermPeriodSettingsHelper.vue';
import LongTermStep from '@/presentation/pages/plants/wizard/LongTermStep.vue';

export default defineComponent({
  name: 'SettingsDialog',
  components: { LongTermPeriodSettingsHelper, LongTermStep },
  props: {
    period: { type: YieldPromiseStatus, required: true },
    company: { type: Company, required: true },
  },
  data() {
    return {
      visible: false,
      updatingPromise: false,
      editablePromisedTotalInKwh: this.period.getPromisedTotal().asKwh(),

      plant: null,
    };
  },
  methods: {
    openSettings() {
      this.visible = true;
      new PlantApi()
        .getSinglePlant(this.company.getId(), this.period.getPlantId())
        .then((rsp) => {
          this.plant = Plant.fromJson(rsp.data);
        });
    },
  },
});
</script>

<template>
  <div>
    <Button outlined class="mt-2" @click="openSettings">
      {{ $t('features.long_term.explainer.change_settings') }}
      <font-awesome-icon icon="arrow-up-right-from-square" class="ml-2" />
    </Button>
    <Dialog
      v-model:visible="visible"
      modal
      :header="$t('features.long_term.step.title')"
      style="width: 56rem"
    >
      <div v-if="company && plant !== null && plant.getId()">
        <long-term-period-settings-helper
          :company="company"
          :plant="plant"
          :period="period"
          @period-updated="visible = false"
          @cancel-clicked="visible = false"
        />
      </div>
    </Dialog>
  </div>
</template>

<style scoped></style>
